import React, { useContext } from 'react';

import { MenuItem } from '@mui/material';
import moment from 'moment';
import styled from 'styled-components';

import { AttendanceContext } from '../../context/AttendanceContext';
import Select from '../forms/Select';

const StyledSelect = styled(Select)`
    min-width: 250px;
`;

export interface ClassSessionSelectProps {
    onChange: (e) => void;
}

const ClassSessionSelect: React.FC<ClassSessionSelectProps> = ({ onChange }) => {
    const { t, sessions, classSessionId } = useContext(AttendanceContext);

    if (!classSessionId) return null;

    const renderOptions = () => {
        const now = new Date();
        //PD-7013 - Sort the sessions by start time now handled in attendnace context.
        //PD-7395 - Sessions should be sorted by start time in descending order for this dropdown only.

        return sessions
            .sort((a, b) => new Date(b.start_time).getTime() - new Date(a.start_time).getTime())
            .map((session) => {
                const startTimeMoment = moment(session.start_time);
                return (
                    <MenuItem key={session.session_id} value={session.session_id}>
                        {startTimeMoment.isSame(now, 'day')
                            ? t('today')
                            : `${startTimeMoment.format('L')} - ${t(startTimeMoment.format('dddd').toLowerCase())}`}
                        {' - '}
                        {startTimeMoment.format('h:mm A')}
                    </MenuItem>
                );
            });
    };

    return (
        <StyledSelect defaultValue={classSessionId} value={classSessionId} name={'class-session'} onChange={onChange}>
            <MenuItem key={0} value={'session-summary'}>
                {t('session-summary')}
            </MenuItem>
            <MenuItem key={1} value={'student-summary'}>
                {t('student-summary')}
            </MenuItem>
            {renderOptions()}
        </StyledSelect>
    );
};

export default ClassSessionSelect;
